var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.02,
    height: 48.835,
    viewBox: "0 0 49.02 48.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    transform: "translate(-114.153 -5729.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M0,45.835H0L3.9,29.788,28.055,6.314l11.07,11.071L15.211,41.3,0,45.834ZM39.2,17.444h0L28.186,6.04l0-.009A20.789,20.789,0,0,1,30.638,3.02C32,1.642,34.085,0,36.286,0A4.471,4.471,0,0,1,36.8.029c1.3.147,2.733,1.456,4.25,2.842C41.655,3.426,42.28,4,42.909,4.5c2.268,1.815,3.3,3.725,3.079,5.675-.252,2.2-2.084,4.057-3.576,5.23A19.474,19.474,0,0,1,39.2,17.444Z",
    transform: "translate(115.653 5730.908)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M-4134.516-610.088l-10.553-11.2",
    transform: "translate(4265.424 6382.304)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.81f07c72fcbea4e78e3c97b767349618.svg";
export { ForwardRef as ReactComponent };